import React, { useEffect, useState } from 'react';
import './App.scss';
import Progress from './components/Progress';
import Processing from './components/Processing';
import ClientInformation from './components/ClientInformation';
import PrimaryContact from './components/PrimaryContact';
import { Contact } from './types/Contact';
import DateAndTime from './components/DateAndTime';
import Confirmation from './components/Confirmation';
import { AvailableTimeSlot } from './types/DynamicsService';
import { dynamicsService } from './services/DynamicsService';
import ReleaseInformation from './components/ReleaseInformation';
import PayFirst from './components/PayFirst';
import { loadStripe } from '@stripe/stripe-js';
import Cookies from 'js-cookie';

function App() {
  const [progress, setProgress] = useState(5);
  const [step, setStep] = useState(1);
  const [client, setClient] = useState<Contact>({
    contactid: undefined,
    firstName: "Test",
    lastName: "Client",
    address1: "",
    address2: "",
    city: "",
    state: "",
    telephone: "",
    zipcode: "",
    email: "",
    dob: "",
  });
  const [primaryContact, setPrimaryContact] = useState<Contact | undefined>();
  const [clientId, setClientId] = useState<string>();
  const [checkoutId, setCheckoutId] = useState<string>();
  const [opportunityId, setOpportunityId] = useState<string>();
  const [timeSlot, setTimeSlot] = useState<AvailableTimeSlot>();
  const [primaryContactId, setPrimaryContactId] = useState<string>();
  
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const contact = params.get("contact");
  const confirm = params.get('confirm') ?? Cookies.get('da-confirm');
  const cancel = params.get('cancel');
  const partner = params.get('partner') ?? undefined;
  
  // Input of a Contact record
  function handleClientInformationComplete(clientId: string, contact: Contact) {
    console.log("handleClientInformationComplete", clientId);
    setClientId(clientId);
    setClient(contact);
    setStep(3);
    setProgress(45);
  }

  // Input of Primary Contact
  function handlePrimaryContactComplete(sameAsPrevious: boolean, primaryContactId: string, primaryContact?: Contact) {
    
    console.log("handlePrimaryContactComplete", primaryContact);
     if (sameAsPrevious) {
       setPrimaryContactId(clientId);
     } else {
       console.log(primaryContactId);
       setPrimaryContactId(primaryContactId);
       setPrimaryContact(primaryContact);
     }
     setStep(4);
     setProgress(66);
  }
  
  // Input of Primary Contact
  function handleReleaseComplete() {
     setStep(5);
     setProgress(66);
  }
  // Selection of a Time Slot
  function handleDateTimeComplete(timeSlot: AvailableTimeSlot) {
    setTimeSlot(timeSlot);
    setStep(0);
    setProgress(90);
    
    dynamicsService.scheduleOpportunity(checkoutId!, clientId!, primaryContactId!, timeSlot.id).then(response => {
      setOpportunityId(response.opportunityId);
      setStep(6);
      Cookies.remove('da-confirm');
    });
    
  }
  // Payment
  function handlePaymentComplete(checkoutId: string) {
    // setOpportunityId(opportunityId);
    setCheckoutId(checkoutId);
    setStep(2);
    setProgress(25);
  }
  function stepBack() {
    setStep(step - 1);
  }
  useEffect(
    () => {
      if (cancel) {
        setStep(1);
        Cookies.remove('da-confirm');
        return;
      }
      if (confirm) {
        Cookies.set('da-confirm', confirm, { expires: 2 });
        setStep(2);
        setProgress(25);
        setCheckoutId(confirm);
      }

      if (contact) {
        // Load the contact and continue with step 2
        setStep(0);
        dynamicsService.getClient(contact).then(response => {
          if (response?.contactid) {
            handleClientInformationComplete(response.contactid, response);
          }
          else {
            console.error("Attempt to fetch Client by ID failed");
            //setStep(1);
          }
        }).catch((reason) => setStep(1));
      }
    },
    [contact, confirm, cancel]
  );

  return <div className="elementor-widget-wrap">
      <Progress value={progress} />
      {step === 0 && <Processing />}
      {step === 1 && <PayFirst onComplete={handlePaymentComplete} partner={partner} />}
      {step === 2 && checkoutId && <ClientInformation checkoutId={checkoutId} onComplete={handleClientInformationComplete} />}
      {step === 3 && clientId && checkoutId && <PrimaryContact checkoutId={checkoutId}  onComplete={handlePrimaryContactComplete} client={client} clientId={clientId} />}
      {step === 4 && clientId && <ReleaseInformation onComplete={handleReleaseComplete} client={client} primaryContact={primaryContact} />}
      {step === 5 && <DateAndTime onComplete={handleDateTimeComplete} client={client} />}
      {opportunityId && <Confirmation opportunityId={opportunityId} />}
      {false && <button onClick={stepBack}>Go Back</button>}
    </div>;
}

export default App;
